function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uD83C\uDF08 COLOR");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-angle-right-Copy",
  transform: "translate(-6.000000, -8.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M14.83,11.29 L10.59,7.05 C10.4022334,6.86068734 10.1466375,6.75420167 9.88,6.75420167 C9.61336246,6.75420167 9.3577666,6.86068734 9.17,7.05 C8.7822764,7.44003745 8.7822764,8.06996254 9.17,8.46 L12.71,12 L9.17,15.54 C8.7822764,15.9300375 8.7822764,16.5599626 9.17,16.95 C9.35871883,17.1371865 9.61419701,17.2415368 9.88,17.2400167 C10.145803,17.2415368 10.4012812,17.1371865 10.59,16.95 L14.83,12.71 C15.0193127,12.5222334 15.1257983,12.2666375 15.1257983,12 C15.1257983,11.7333625 15.0193127,11.4777666 14.83,11.29 Z",
  id: "\\uD83C\\uDF08-COLOR",
  transform: "translate(12.002503, 11.997109) rotate(-270.000000) translate(-12.002503, -11.997109) "
})));

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.8eece099.svg";
export { ForwardRef as ReactComponent };